var render = function (_h,_vm) {var _c=_vm._c;return _c('td',{class:[
    _vm.data.class,
    _vm.data.staticClass,
    'ten-date-item', {
      'ten-date-item--active': _vm.props.active,
      'ten-date-item--disabled': _vm.props.disabled,
      'ten-date-item--highlight': _vm.props.highlight,
      'ten-date-item--active-start': _vm.props.startOfRange,
      'ten-date-item--active-end': _vm.props.endOfRange,
      'ten-date-item--additional': _vm.props.additional,
      'ten-date-item--now': _vm.props.now,
      'ten-date-item--first-day-of-month': _vm.props.firstDayOfMonth,
      'ten-date-item--last-day-of-month': _vm.props.lastDayOfMonth
    }
  ]},[_vm._t("default",function(){return [_c('div',{staticClass:"ten-date-item__wrapper",on:{"click":function() {
        if (!_vm.props.disabled) {
          _vm.props.onClick(_vm.props.value)
        }
      },"mouseenter":function() {
        _vm.props.onMouseEnter(_vm.props.value);
      }}},[_c('span',{staticClass:"ten-date-item__text"},[_vm._v(_vm._s(_vm.props.text))])])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }